import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectUserActiveEmployerBusinessId } from 'store/user/selectors.js/user.selectors';
import { getActiveProjectAssignments } from '../services/getActiveProjectAssignments';

// return only assignments not marked as deleted
export const loadActiveAssignmentsForProject = createAsyncThunk(
  'assignments/loadActiveAssignmentsForProject',
  async (projectId, { getState }) => {
    const projectAssignments = await getActiveProjectAssignments(
      projectId,
      selectUserActiveEmployerBusinessId(getState())
    );
    return projectAssignments;
  }
);
